import type { CartItem, SetCart } from "./utils/CartHelper";
import cartIcon from "../assets/icons/shopping-cart.svg";
import closeIcon from "../assets/icons/close.svg";
import { useState } from "react";

interface CartProps {
  cart: CartItem[];
  setCart: SetCart;
}

function openPopup(item: CartItem) {
  let c_event = new CustomEvent("open-popup", {
    detail: {
      assetId: item.id,
    },
  });

  document.dispatchEvent(c_event);
}

export const Cart: React.FC<CartProps> = ({ cart, setCart }) => {
  let [cartOpen, setCartOpen] = useState(false);
  function startCheckout() {
    document.dispatchEvent(new CustomEvent("open-checkout"));
  }

  function clearCart() {
    setCart([]);
    setCartOpen(false);
  }
  return (
    <div className={cartOpen ? "cart open" : "cart"}>
      <div
        className={cart.length ? "cart__button has-content" : "cart__button"}
        onClick={() => {
          setCartOpen(!cartOpen);
        }}
        data-items={cart.length}
        title={cartOpen ? 'Close Cart' : 'Open Cart'}
      >
        <img src={cartIcon} className="icon icon-xl" alt="Shopping Cart Icon" />
      </div>
      <div className="cart__pane">
        <h2 className="sidebar-area-header">
          <img
            src={cartIcon}
            className="icon icon-xl"
            alt="Shopping Cart Icon"
          />
          <div className="flex-fill">Your Selection</div>
        </h2>
        <ul className="cart__list">
          {cart.map((item) => (
            <li key={item.id} className="cart__item" title={item.name}>
              <div
                className="cart__item__title"
                role="button"
                onClick={() => openPopup(item)}
              >
                <img
                  src={item.imageURL}
                  className="icon icon-md"
                  alt="Thumbnail"
                />
                {item.name}
              </div>
              <div className="cart__item__actions">
                <button
                  className="btn"
                  onClick={() =>
                    setCart((cart) => cart.filter((i) => i.id !== item.id))
                  }
                >
                  <img src={closeIcon} alt="" className="icon icon-sm" />
                </button>
              </div>
            </li>
          ))}
        </ul>
        <div className="cart__checkout">
          <button className="btn btn-primary my-1" onClick={startCheckout}>
            Download
          </button>
          <button className="btn btn-white" onClick={clearCart}>
            Clear Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
